import * as React from 'react';
import { OutputReferenceHelper } from '../../helpers';
import { IDropdownOption, TextField, Button, ButtonType, Dropdown } from 'office-ui-fabric-react';

interface IProps {
	outputOptions: IDropdownOption[];
	indexSelectOutputOptions: IDropdownOption[];
	top: number;
	outputSearchElementId: string;
	focusedOutputKey: string;
	outputLookupRequestIndexForOutputId: string;
	outputLookupIndex: string;
	outputSelectIndexChange: (val: string) => void;
	outputSelectIndexConfirm: () => void;
	outputSelectIndexCancel: () => void;

}

export class OutputSelect extends React.Component<IProps, any> {

	public componentDidMount() {

		let { outputOptions } = this.props;

		//select the first item
		OutputReferenceHelper.setFocusedOutputKey(outputOptions && outputOptions.length ? outputOptions[0].key.toString() : '');

	}

	public componentDidUpdate(prevProps: IProps) {

		let { outputOptions } = this.props;

		if (!OutputReferenceHelper.outputArraysAreEqual(outputOptions, prevProps.outputOptions)) {
			//select the first item			
			OutputReferenceHelper.setFocusedOutputKey(outputOptions && outputOptions.length ? outputOptions[0].key.toString() : '');
		}
	}

	public componentWillUnmount() {
		OutputReferenceHelper.clearOutputReferenceSearch();
	}

	outputSelectIndexTextFieldChange = (option: IDropdownOption) => {

		this.props.outputSelectIndexChange(option.key.toString());

	};

	public render() {

		let { outputOptions, top, outputSearchElementId, focusedOutputKey, outputLookupRequestIndexForOutputId, outputLookupIndex, outputSelectIndexConfirm,
			outputSelectIndexCancel, outputSelectIndexChange, indexSelectOutputOptions } = this.props;

		if (outputLookupRequestIndexForOutputId && outputLookupRequestIndexForOutputId.length) {

			let outputOption = outputOptions.filter(o => o.key === outputLookupRequestIndexForOutputId)[0];

			let confirmDisabled = !(outputLookupIndex && outputLookupIndex.length);

			if (outputOption) {
				return <div style={{ top: top + 'px' }} className="output-select-index-wrapper">
					{ }
					{<Dropdown
						label={'Please specify the output that holds the index to use for output array "' + outputOption.text + '":'}
						options={indexSelectOutputOptions}
						onChanged={this.outputSelectIndexTextFieldChange}
						selectedKey={outputLookupIndex && outputLookupIndex.length ? outputLookupIndex : null}
					/>}
					{<div className="output-select-index-buttons">
						<Button
							buttonType={ButtonType.icon}
							icon='CheckMark'
							onClick={confirmDisabled ? null : outputSelectIndexConfirm}
							disabled={confirmDisabled}
						/>
						<Button
							buttonType={ButtonType.icon}
							icon='Cancel'
							onClick={outputSelectIndexCancel}
						/>
					</div>}
				</div>;
			}

		}

		let options: JSX.Element[] = outputOptions.map((o, i) => {
			return (
				<li key={'output_' + o.key} id={'output_' + o.key} className={focusedOutputKey === o.key ? 'focused' : ''}
					onMouseEnter={() => {
						OutputReferenceHelper.setSaveOnBlur(false);
						OutputReferenceHelper.setFocusedOutputKey(o.key.toString());
					}}
					onMouseLeave={() => {
						OutputReferenceHelper.setSaveOnBlur(true);
						if (focusedOutputKey === o.key.toString()) {
							OutputReferenceHelper.setFocusedOutputKey("");
						}
					}}
					onMouseDown={(e) => {
						e.preventDefault(); //this prevents the scrollbar in modals from moving upwards which would prevent the onClick event from firing
					}}
					onClick={() => {
						OutputReferenceHelper.outputSelect(o.key.toString(), outputSearchElementId);
					}}
				>{o.text}</li>
			);
		});

		let ulStyle = {
			top: top + 'px'
		};

		return (
			<ul style={ulStyle} className='suggestions output-select'>
				{options}
			</ul>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/output-reference/output-select.tsx